<!--课程学习抓拍记录-->
<template>
  <div
    class="hbn-container"
    id="userInfo"
    v-loading="loading"
    element-loading-text="文件导出中..."
    element-loading-background="rgba(122, 122, 122, 0.8)"
  >
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            label-position="right"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="课程名称">
                  <el-input
                    id="Name"
                    v-model="PageQuery.queryModel.courseTitle"
                    placeholder="课程名称"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="章节名称">
                  <el-input
                    id="Name"
                    v-model="PageQuery.queryModel.courseChapterTitle"
                    placeholder="章节名称"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="用户姓名">
                  <el-input
                    id="Name"
                    v-model="PageQuery.queryModel.userName"
                    placeholder="用户姓名"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="show" :gutter="24">
              <el-col :span="8">
                <el-form-item label="手机号">
                  <el-input
                    id="Name"
                    v-model="PageQuery.queryModel.phone"
                    placeholder="手机号"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="抓拍时间">
                  <el-date-picker
                    v-model="PageQuery.queryModel.courseChapterTime"
                    type="datetimerange"
                    range-separator=" - "
                    start-placeholder="开始"
                    end-placeholder="结束"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button size="mini" class="hbn-button-serach" @click="seach"
              >查找</el-button
            >
            <span class="control-collapse" @click="show = !show">{{
              show ? "收起" : "展开"
            }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <div class="hbn-table-screen">
      <div class="operation">
        <el-button type="primary" class="custom-button" @click="export2Excel">
          <i class="el-icon-download custom-icon"></i>
          <span>导出</span>
        </el-button>
      </div>

      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            :data="DataList"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            @current-change="handleCurrentChange"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>

            <template v-for="(item, key) in UnitList" :key="key">
              <vxe-table-column
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                v-if="item.isShow"
                show-overflow-tooltip
                :class-name="JSON.stringify(item)"
                :formatter="formatterData"
              >
                <template
                  v-if="item.format === 'image'"
                  #default="{ rowIndex, row }"
                >
                  <img
                    style="width: 30px; height: 30px; cursor: pointer"
                    :src="row[item.prop]"
                    alt=""
                    title="点击可放大对比图片"
                    @click="
                      currentRow = row;
                      dialogVisible = true;
                    "
                  />
                </template>
              </vxe-table-column>
            </template>
          </vxe-table>
        </div>

        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
          </vxe-pager>
        </div>
      </div>
    </div>
    <CourseSnapContrast
      :dialogVisible="dialogVisible"
      :currentRow="currentRow"
      @handle-cancel="dialogVisible = false"
    ></CourseSnapContrast>
  </div>
</template>

<script>
import { Search } from "@element-plus/icons";
import { CourseRecordSnapList } from "@/assets/apiData/CourseRecordSnap";
import {
  GetDataCourseSnapList,
  ExportDataCourseSnap,
} from "@api/ApiCourseRecordSnap";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";
import { dateFormat } from "@/util/utils.js";
import CourseSnapContrast from "@comp/Course/CourseSnapContrast.vue";
export default {
  data() {
    return {
      PageQuery: {
        queryModel: {
          courseTitle: "",
          courseChapterTitle: "",
          userName: "",
          phone: "",
          courseChapterTime: "",
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      show: false,
      UnitList: [],
      DataList: [],
      loading: false,
      options: [],
      dialogVisible: false,
      currentRow: {},
    };
  },
  components: {
    excel,
    Search,
    CourseSnapContrast,
  },
  methods: {
    export2Excel() {
      let beginDate = "";
      let endDate = "";
      if (this.PageQuery.queryModel.courseChapterTime) {
        beginDate = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          this.PageQuery.queryModel.courseChapterTime[0]
        );
        endDate = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          this.PageQuery.queryModel.courseChapterTime[1]
        );
      }
      this.PageQuery.queryModel = {
        ...this.PageQuery.queryModel,
        beginDate,
        endDate,
      };
      ExportDataCourseSnap(this.PageQuery.queryModel).then((res) => {});
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },

    handleSizeChange(val) {
      //分页
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.GetData();
    },
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS", cellValue);
          break;
        case "decimal":
          cellValue = cellValue != null ? parseFloat(cellValue).toFixed(2) : 0;
          break;
      }
      return cellValue;
    },
    GetData() {
      let beginDate = "";
      let endDate = "";
      if (this.PageQuery.queryModel.courseChapterTime) {
        beginDate = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          this.PageQuery.queryModel.courseChapterTime[0]
        );
        endDate = dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          this.PageQuery.queryModel.courseChapterTime[1]
        );
      }
      this.PageQuery.queryModel = {
        ...this.PageQuery.queryModel,
        beginDate,
        endDate,
      };
      const _this = this;
      this.SearchDataInfo();
      try {
        GetDataCourseSnapList(_this.PageQuery).then(function (data) {
          _this.DataList = data.entities;
          _this.total = data.totalCount;
        });
      } catch (e) {
        console.log(e);
      }
    },
    SearchDataInfo() {},
  },
  created() {
    this.UnitList = CourseRecordSnapList;
    this.GetData();
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
#userInfo {
}
</style>
<style scoped>
</style>
